import React, { useMemo, useState, useContext} from "react"
import {Box, Button, IconButton, Stack, styled, Typography} from "@mui/material"
import { Trash } from "lucide-react"
import { widgetFromDomaintypeGenerator } from "../../../misc/widget-functions"
import Content from "../../../components/Content"
import {DataContext} from "../../../../src/context/DataContextProvider"

const LabelTypography = styled(Typography)(({theme}) => theme.ProduktSucheEntry)
const TrashIcon = styled(Trash)(({theme}) => theme.PRODUKT_SUCHE_TRASH_ICON)

const Listenobjekt = ({listObject, unterobjekt}) => {
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const [listObjectArray, setListObjectArray] = useState([])
    const handleAdd = listObject =>
        setListObjectArray([...listObjectArray, listObject])
    const handleDelete = indexToDelete => {
        const pointer = `/${unterobjekt.id}`
        const currentValueArray = getDataFromPointer(pointer) ?? []
        const newValueArray = currentValueArray.filter(
            (_, index) => index !== indexToDelete,
        )
        updateData(newValueArray, pointer)
        setListObjectArray(
            listObjectArray.filter((_, index) => index !== indexToDelete),
        )
    }

    return useMemo(
        () => (
            <Box display="grid" gridTemplateColumns="1fr 1fr" gap="5px">
                <LabelTypography variant="body1">
                    {listObject.label}
                </LabelTypography>
                <Button onClick={() => handleAdd(listObject)}>
                    Hinzufügen
                </Button>

                {listObjectArray.map((listenobjekt, index) => (
                    <>
                        <LabelTypography variant="h2">
                            {listenobjekt.label} {index + 1}
                            <IconButton onClick={() => handleDelete(index)}><TrashIcon /></IconButton>
                        </LabelTypography>

                        <Stack>
                            {listenobjekt?.children?.map(merkmal => (
                                <>
                                    <LabelTypography variant="body1">
                                        {merkmal.question || merkmal.label}
                                    </LabelTypography>

                                    <Content
                                        child={widgetFromDomaintypeGenerator(
                                            merkmal,
                                            `/${unterobjekt.id}/${index}/${merkmal.id}`,
                                        )}
                                    />
                                </>
                            ))}
                        </Stack>
                    </>
                ))}
            </Box>
        ),
        [listObject, listObjectArray],
    )
}

export default Listenobjekt
